import { observer } from 'mobx-react-lite'
import React, { useContext } from 'react'
import { SearchContext } from '../../../../../contexts/SearchContext'
import SegmentedControl from '../../../../Shared/SegmentedControl'

const OPTIONS = [
  { value: 'female', label: 'Female', title: 'Mostly female audience' },
  { value: 'male', label: 'Male', title: 'Mostly male audience' },
  { value: 'equal', label: 'Balanced', title: 'Balanced audience' }
]

export default observer(function AudienceGenderFilter() {
  const { search } = useContext(SearchContext)

  const select = type => {
    search.audience_gender = search.audience_gender === type ? '' : type
  }

  return <SegmentedControl options={OPTIONS} isActive={value => search.audience_gender === value} onSelect={select} className="w-full [&>button]:flex-1" />
})
